import { render, staticRenderFns } from "./TableChildren.vue?vue&type=template&id=2f2b0cd4"
import script from "./TableChildren.vue?vue&type=script&lang=ts"
export * from "./TableChildren.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports